// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Jordan from '../_raw/flag/icon_flag_jordan.png';

export default () => <img src={Jordan} alt="Jordan" />;
